(ns dashboard.views.questionnaire.question-list.view
  (:require ["react" :as react]
            [clojure.string :as str]
            [dashboard.common :as common :refer [expanded-text-container-style
                                                 wrapped-text-container-style]]
            [dashboard.components.answer-options :refer [AnswerOptions]]
            [dashboard.components.breadcrumbs :refer [breadcrumbs]]
            [dashboard.components.paginated-list.view :as paginated-list]
            [dashboard.components.questionnaire.notes-button :refer [notes-button]]
            [dashboard.components.questionnaire.question-filter-popup :as question-filter-popup]
            [dashboard.components.questionnaire.questionnaire-status :refer [questionnaire-status]]
            [dashboard.components.questionnaire.section-tabs :refer [section-tabs]]
            [dashboard.entity.analysis.db :as analysis.db]
            [dashboard.entity.analysis.modals :as applied-analysis]
            [dashboard.entity.analysis.profile :as analysis.profile]
            [dashboard.entity.question.answer-scope :as answer-scope]
            [dashboard.entity.question.comparison :as compare.answer]
            [dashboard.entity.question.db :as questions.db]
            [dashboard.entity.question.editable-answer-field :as edit.answer]
            [dashboard.entity.question.profile :as question.profile]
            [dashboard.entity.question.question-status :as question-status]
            [dashboard.entity.questionnaire.db :as questionnaire.db]
            [dashboard.entity.questionnaire.progress-bar :as progress.bar]
            [dashboard.html :as html]
            [dashboard.services.answers :as answers]
            [dashboard.services.document-list :as documents]
            [dashboard.services.question-note :as question-note]
            [dashboard.services.questionnaire-list :as questionnaire-list]
            [dashboard.services.questionnaires :as questionnaires]
            [dashboard.subs :as common-subs]
            [dashboard.utils :as utils]
            [dashboard.views.analysis.common :as analysis]
            [dashboard.views.analysis.structured-analysis.browse-structured-analyses :as browse-structured-analyses]
            [dashboard.views.analysis.structured-analysis.view-structured-analysis-modal :as view-structured-analysis]
            [dashboard.views.questionnaire.components.archived-list :as archives]
            [dashboard.views.questionnaire.components.inference-job-list :as inference-jobs]
            [dashboard.views.questionnaire.components.title :as title]
            [dashboard.views.questionnaire.question-lab.events :as question-lab.events]
            [dashboard.views.questionnaire.question-list.config :as config]
            [dashboard.views.questionnaire.questions.view :as questions.view]
            [re-frame.core :as rf]))

(def controllers
  [{:parameters {:path [:questionnaire-id]}
    :start (fn [{{:keys [questionnaire-id]} :path}]
             (let [questionnaire-id (uuid questionnaire-id)]
               (analysis.db/get-applied-analyses false)
               (analysis.db/get-categories false)
               (analysis.db/get-structured-analyses false)
               (analysis.db/get-structured-analysis-questions false)
               (questionnaire.db/get-attachments questionnaire-id)
               (questionnaire.db/get-questions questionnaire-id nil)
               (questionnaire.db/get-metadata questionnaire-id nil)
               (questions.db/get-sections questionnaire-id)
               (questions.db/init-comparisons questionnaire-id)
               (questions.db/init-view questionnaire-id)
               (rf/dispatch [::answer-scope/get])
               (rf/dispatch [::archives/fetch-archived-list questionnaire-id])
               (rf/dispatch [::documents/get])
               (rf/dispatch [::inference-jobs/fetch-jobs questionnaire-id])
               (rf/dispatch [::inference-jobs/get-start-configuration questionnaire-id])
               (rf/dispatch [::inference-jobs/start-polling questionnaire-id])
               (rf/dispatch [::question-note/get-notes questionnaire-id])
               (rf/dispatch [::question-note/get-notes-last-seen questionnaire-id])
               (rf/dispatch [::question-note/start-polling-for-notes questionnaire-id])
               (rf/dispatch [::questionnaire-list/get])))
    :stop (fn [{{:keys [questionnaire-id]} :path}]
            (let [questionnaire-id (uuid questionnaire-id)]
              (rf/dispatch [::question-note/stop-polling-for-notes])
              (rf/dispatch [::inference-jobs/stop-polling questionnaire-id])))}])

(defn response-sort-keyfn [question]
  (or (question.profile/question->response question) "zzz"))

(defn comment-sort-keyfn [question]
  (or (question.profile/question->comment question) "zzz"))

(defn status-sort-keyfn [question]
  (or (:status question) "n/a"))

(defn analysis-sort-keyfn [question]
  (or (some-> question :selected-answer :analysis :content) "zzz"))

(def symbol->background
  {"T" "#209CEE"
   "Q" "black"
   "A" "purple"})

(defn ComparisonSymbol [short-symbol short-id]
  [:span.mr-1.has-text-white.has-text-weight-bold
   {:style {:display "inline-block"
            :border-radius "50%"
            :background (symbol->background short-symbol)
            :width "1.7em"
            :height "1.7em"
            :line-height "1.7em"
            :text-align "center"}}
   (str short-symbol short-id)])

(defn SuggestedAnalyses [suggested-structured-analyses question questionnaire-id]
  (let [[load-state set-load-state] (react/useState {})]
    [:table {:class "ml-2"
             :style {:width "100%"
                     :border-collapse "collapse"}}
     [:tbody
      (for [{:keys [applied-analysis] construct-id :construct-id :as structured-analysis} suggested-structured-analyses
            :let [{:keys [state-id version-id]} applied-analysis
                  analysis-load-state (get load-state version-id)
                  {:keys [states construct]} structured-analysis
                  id->state (into {} states)]]
        [:tr
         {:key construct-id
          :style {:background-color "unset"}}
         [:td.p-0
          {:style {:border "none"}}
          [:a.is-flex
           {:title (if applied-analysis
                     "Click to view the applied analysis"
                     "Click to create the applied analysis")
            :on-click #(if applied-analysis
                         (applied-analysis/show-editor-modal construct-id :view applied-analysis)
                         (applied-analysis/show-editor-modal construct-id :edit nil))}
           (analysis.profile/format-analysis-id construct-id)
           [:span.ml-2 construct]]]
         [:td.p-0
          {:style {:border "none"}}
          (if applied-analysis
            [analysis.profile/state-tag {:class ["is-small" "ml-2"]} (id->state state-id)]
            [:a.ml-2
             {:title "Applied analysis is missing, click to create applied analysis"
              :on-click #(applied-analysis/show-editor-modal construct-id :edit nil)}
             "???"])]
         [:td.p-0
          {:style {:border "none"}}
          (let [linked-construct-ids (into #{} (map :construct-id (-> question :selected-answer :applied-analyses)))]
            [:div.is-flex
             [:button.button.is-rounded.is-circular.is-small.is-info.ml-2
              {:disabled (or (not applied-analysis)
                             (contains? linked-construct-ids construct-id))
               :title (cond
                        (not applied-analysis) "Applied analysis is missing, click on the construct to create applied analysis"
                        (contains? linked-construct-ids construct-id) "Applied analysis already linked"
                        :else "Link the sugegsted applied analysis to answer of question.\n\nCreates and selects an answer, if question has no answer yet.")
               :on-click #(analysis.db/link-analysis
                           (fn [applied-analysis-version-ids state]
                             (set-load-state (into {} (map (fn [version-id]
                                                             [version-id state])
                                                           applied-analysis-version-ids))))
                           questionnaire-id
                           (:id question)
                           #{applied-analysis})}
              (if analysis-load-state
                [:div.loader]
                [:span.icon>i.fas.fa-link])]
             [:button.button.is-rounded.is-circular.is-small.ml-2
              {:title "Tell the system that the suggestion was not good"
               :on-click #(questions.db/report-analysis-suggestion (:content question) construct false)}
              [:span.icon.i.fas.fa-regular.fa-thumbs-down]]])]])]]))

(defn make-columns [features-enabled]
  [{:label "#"
    :id :display-name
    :classes ["is-narrow"]
    :sort-key :ordinal
    :render (fn [{:keys [display-name suggestion suggestion-type short-id target-questionnaire]}]
              (if suggestion
                [:div.ml-2
                 [ComparisonSymbol
                  (if (= :questionnaire suggestion-type)
                    (if (:template target-questionnaire)
                      "T"
                      "Q")
                    "A")
                  (when (= :questionnaire suggestion-type)
                    short-id)]]
                [:span display-name]))}
   {:label "Section"
    :id :section
    :sort-key (juxt :section-ordinal :ordinal)
    :render (fn [{:keys [section-name]}]
              (html/strip-markup section-name))}
   {:label "Question"
    :id :content
    :sort-key :content
    :render (fn [{:keys [content suggestion suggestion-type]
                  :tree/keys [depth]}]
              (if (= suggestion-type :analysis)
                nil
                [:div
                 {:class (when suggestion
                           "ml-2")
                  :style (when-not suggestion
                           {:padding-left (str (* (dec depth) 24) "px")})}
                 (when (and (not suggestion)
                            (> depth 0))
                   [:div.mr-2.branch-icon])
                 (html/as-hiccup-with-anchors (if suggestion
                                                (:content suggestion)
                                                content))]))}
   {:label "Applied Analysis"
    :id :applied-analysis
    :title "Applied analyses linked to the selected answer"
    :sort-key (fn [question]
                (mapv :structured-analysis-id (-> question :selected-answer :applied-analyses)))
    :render (fn [{:keys [suggestion questionnaire-id] :as question}]
              (if suggestion
                (when-let [suggested-structured-analyses (-> suggestion :structured-analyses seq)]
                  [:f> SuggestedAnalyses suggested-structured-analyses question questionnaire-id])
                [:f> analysis/applied-analysis-column
                 (-> question :selected-answer :applied-analyses)
                 questionnaire-id
                 question
                 (-> question :selected-answer :id)
                 (if suggestion true false)]))
    :features #{:applied-analysis-creation}}
   {:label "Response"
    :id :response
    :sort-key response-sort-keyfn
    :render (fn [{:keys [selected-answer] :as question}]
              [:div
               (when-let [options (if selected-answer
                                    (seq (:options selected-answer))
                                    ;; If there is no answer yet, show options available from the question
                                    (seq (:options question)))]
                 [AnswerOptions
                  {:options options
                   :on-change (fn [multi id]
                                (let [selected-option-ids (set (keep (fn [{:keys [id selected]}]
                                                                       (when selected
                                                                         id))
                                                                     options))
                                      options (if multi
                                                (if (contains? selected-option-ids id)
                                                  (disj selected-option-ids id)
                                                  (conj selected-option-ids id))
                                                #{id})]
                                  (questions.db/commit-edit
                                   question
                                   :options
                                   (map (fn [id]
                                          {:id id
                                           :selected true})
                                        options))))}])
               [:div
                {:style {:height (when (str/blank? (question.profile/question->response question))
                                   "2em")}}
                [:f> edit.answer/EditableAnswerField
                 :response
                 "response"
                 question.profile/question->response
                 (fn [question field-key content]
                   (questions.db/commit-edit question
                                             field-key
                                             content))
                 question
                 false]]])
    :features #{:applied-analysis-creation}}
   {:label "Comment"
    :id :comment
    :sort-key comment-sort-keyfn
    :render (fn [{:keys [selected-answer] :as question}]
              ;; TODO: We should migrate the use of :additional-information to :comment, in database, backend and frontend
              ;;       Database first, so we could then drop use of :additional-information in backend and frontend
              (let [comment-key (cond
                                  (contains? selected-answer :additional-information) :additional-information
                                  (contains? selected-answer :comment) :comment
                                  :else :comment)]
                [:f> edit.answer/EditableAnswerField
                 comment-key
                 "comment"
                 question.profile/question->comment
                 (fn [question field-key content]
                   (questions.db/commit-edit question
                                             field-key
                                             content))
                 question
                 false]))
    :features #{:applied-analysis-creation}}
   {:label "Unstructured Analysis"
    :id :unstructured-analysis
    :sort-key analysis-sort-keyfn
    :render (fn [{:keys [selected-answer suggestion]}]
              (let [[overflow-hidden? set-overflow-hidden] (react/useState true)]
                (when-not suggestion
                  [:div {:style (if overflow-hidden? wrapped-text-container-style expanded-text-container-style)
                         :on-click #(set-overflow-hidden (not overflow-hidden?))}
                   [:span
                    (when-let [content (some-> selected-answer :analysis :content)]
                      (html/as-hiccup-with-anchors content))]])))
    :features #{:applied-analysis-creation}}
   {:label "Structured Analysis"
    :id :structured-analysis
    :sort-key (fn [question]
                (mapv :construct-id (:structured-analyses question)))
    :render (fn [{:view/keys [features-enabled] :as question}]
              (let [[load-state set-load-state] (react/useState {})]
                [:div
                 (when (seq (:structured-analyses question))
                   [:div.mr-2
                    (doall (map (fn [versions]
                                  (let [{:keys [construct-id construct]} (first versions)]
                                    [:div.is-flex.is-align-items-center
                                     {:key construct-id}
                                     [:a.is-flex
                                      {:on-click #(rf/dispatch [::view-structured-analysis/show-view-modal construct-id])}
                                      [:span (analysis.profile/format-analysis-id construct-id)]
                                      [:span.ml-2 construct]]
                                     (when (contains? features-enabled :structured-analysis-creation)
                                       [:button.button.is-rounded.is-circular.is-small.is-danger.ml-2
                                        {:title "Unlink the structured analysis from the the question"
                                         :class (when (get load-state construct-id)
                                                  "is-loading")
                                         :on-click (fn [_]
                                                     (rf/dispatch [::browse-structured-analyses/set-structured-analysis-for-question
                                                                   (:id question)
                                                                   (set (keep (fn [structured-analyses]
                                                                                (let [structured-analysis (first structured-analyses)]
                                                                                  (when (not= construct-id (:construct-id structured-analysis))
                                                                                    {:construct-id (:construct-id structured-analysis)
                                                                                     :structured-analysis-version-uuid (:version-id structured-analysis)})))
                                                                              (:structured-analyses question)))
                                                                   (fn [state]
                                                                     (case state
                                                                       :start (set-load-state (assoc load-state construct-id true))
                                                                       :complete (set-load-state (assoc load-state construct-id false))))]))}
                                        [:span.icon>i.fas.fa-unlink]])]))
                                (:structured-analyses question)))])
                 (when (contains? features-enabled :structured-analysis-creation)
                   [:button.button.is-rounded.is-secondary.is-small
                    {:title "Link Structured Analyses to the question"
                     :on-click #(rf/dispatch [::browse-structured-analyses/show-modal question])}
                    [:span.icon>i.fas.fa-folder-tree]])]))
    :features #{:structured-analysis-creation}}
   {:label "Answer scope"
    :id :answer-scope
    :sort-key (comp :content :answer-scope)
    :render (fn [{:keys [suggestion] :as question}]
              (when-not suggestion
                [:div (-> question :answer-scope :content)]))
    :features #{:applied-analysis-creation}}
   {:label "Status"
    :id :status
    :classes ["is-narrow"]
    :sort-key status-sort-keyfn
    :render (fn [{:keys [id status questionnaire-id selected-answer disabled suggestion]}]
              (when-not suggestion
                (let [update-status #(questionnaire.db/update-question-status
                                      questionnaire-id
                                      id
                                      %)]
                  [:div
                   [question-status/status-button {:status "approved"
                                                   :current-status status
                                                   :on-click (partial update-status "approved")
                                                   :selected-answer selected-answer
                                                   :disabled disabled}]
                   [question-status/status-button {:status "in-review"
                                                   :current-status status
                                                   :on-click (partial update-status "in-review")
                                                   :selected-answer selected-answer
                                                   :disabled disabled}]
                   [question-status/status-button {:status nil
                                                   :current-status status
                                                   :on-click (partial update-status nil)
                                                   :selected-answer selected-answer
                                                   :disabled disabled}]])))
    :features #{:applied-analysis-creation}}
   {:label   ""
    :id :actions
    :classes ["is-narrow"]
    :render  (fn [{:keys [questionnaire-id disabled suggestion] :as question}]
               (when-not suggestion
                 [:span
                  (when (contains? features-enabled :applied-analysis-creation)
                    (let [question-ids @(questions.db/lab-question-ids* questionnaire-id)]
                      [:a.button.is-secondary.is-small.is-rounded.mr-2
                       (cond-> {:class (when disabled "is-disabled")
                                :title "Open question in Question Lab View"}
                         (not disabled)
                         (assoc :on-click
                                #(rf/dispatch [::question-lab.events/show-question-lab-modal
                                               question
                                               question-ids])))
                       [:span.icon>i.fas.fa-flask]]))
                  [notes-button question]]))}])

(defn filter->tag [questionnaire-id [filter-name filter-value]]
  (when filter-value
    (case filter-name
      "unread-notes"
      [:span.tag.is-primary {:key filter-name}
       "unread notes"
       [:button.delete.is-small
        {:on-click #(questions.db/set-filters
                     questionnaire-id
                     {filter-name nil})
         :title "Remove filter"}]]

      "section"
      [:span.tag.is-secondary {:key filter-name}
       "section: "
       (html/as-hiccup-with-anchors (:name filter-value))
       [:button.delete.is-small
        {:on-click #(questions.db/set-filters
                     questionnaire-id
                     {filter-name nil})
         :title "Remove filter"}]]

      #_:else
      (let [nameparts (str/split filter-name "/")]
        ^{:key filter-name}
        [:span.tag {:class (case (second nameparts)
                             "approved" "is-success"
                             "in-review" "is-warning"
                             "is-danger")}
         (str (first nameparts) ": " (str/capitalize (second nameparts)))
         [:button.delete.is-small
          {:on-click #(questions.db/set-filters
                       questionnaire-id
                       {filter-name false})
           :title "Remove filter"}]]))))

(def template-columns
  #{:display-name :content :structured-analysis})

(defn Compare [questionnaire-id idx {:keys [target-questionnaire] :as comparison}]
  (let [{:keys [loading load-success]} @(rf/subscribe [::questions.db/comparison-suggestions questionnaire-id (:id target-questionnaire)])]
    [:div.is-flex.is-align-items-center
     [:label
      {:for (str "template-" idx)}
      [:span "Compare with"]]
     [:div.select.is-rounded.ml-2
      {:class (cond
                loading
                "is-loading"

                (and (seq comparison)
                     (not loading)
                     (not load-success))
                "is-danger")}
      [:select
       {:id (str "template-" idx)
        :value (if-let [{:keys [id template]} target-questionnaire]
                 (if template
                   (str "template," id)
                   (str "questionnaire," id))
                 "clear-selection,")
        :on-change #(let [[option-type,value] (str/split (.. % -target -value) #",")]
                      (if (= "clear-selection" option-type)
                        (questions.db/clear-comparison-target questionnaire-id
                                                              target-questionnaire)
                        (let [target-questionnaire-id (parse-uuid value)]
                          (questions.db/get-suggestions idx
                                                        questionnaire-id
                                                        target-questionnaire-id))))}
       [:option
        {:value "clear-selection,"}
        ""]
       (for [{:keys [id custom-name filename]} @(rf/subscribe [::questionnaire-list/data :template])]
         [:option
          {:key id
           :value (str "template," id)}
          (str "Template: " (or custom-name filename))])
       (for [{:keys [id custom-name filename]} @(rf/subscribe [::questionnaire-list/data (fn [questionnaire]
                                                                                           (and (not (:template questionnaire))
                                                                                                (not= questionnaire-id (:id questionnaire))))])]
         [:option
          {:key id
           :value (str "questionnaire," id)}
          (str "Questionnaire: " (or custom-name filename))])]]]))

(defn deprecated-table-view
  [toggle-view]
  (let [{:keys [path]} @(rf/subscribe [::common-subs/route-parameters])

        questionnaire-id (-> path :questionnaire-id uuid)

        filter-popup-visible? @(questions.db/filter-popup-visible*)
        filters @(questions.db/filters* questionnaire-id)

        [status-frequencies
         total-questions] @(rf/subscribe
                            [::questionnaires/question-status-frequencies
                             questionnaire-id])

        sections @(rf/subscribe [::questionnaires/sections questionnaire-id])
        current-section (get filters "section")

        questionnaire @(rf/subscribe [::questionnaires/questionnaire questionnaire-id])

        loading-metadata? (-> questionnaire :metadata :loading)
        questionnaire-type (-> questionnaire :metadata :data :type)
        title (or (-> questionnaire :metadata :data :custom-name)
                  (-> questionnaire :metadata :data :filename))
        template-questionnaire? (-> questionnaire :metadata :data :template)

        features-enabled @(rf/subscribe [::common-subs/features-enabled])

        questions @(questions.db/questions* questionnaire-id)

        columns (make-columns features-enabled)

        comparisons @(questions.db/comparisons* questionnaire-id)]
    [:<>
     [:div.level.my-0
      [breadcrumbs {:items (config/breadcrumbs {:id questionnaire-id
                                                :title title})}]
      (when (contains? features-enabled :applied-analysis-creation)
        [:button.button.is-tertiary.is-small.is-rounded.mt-2.mr-6.mb-0
         {:on-click #(toggle-view not)}
         "Question Answering"])]
     (when (and (contains? features-enabled :applied-analysis-creation)
                (not (-> questionnaire :questions :loading)))
       [:div.sticky.mx-6
        [progress.bar/progress-bar status-frequencies total-questions]])
     [:div.section.py-0.question-list
      [:div.section.py-4
       [:div.level
        [:div.level-left
         (if loading-metadata?
           [:div.loader]
           [title/title questionnaire-id (-> questionnaire :metadata :data)])]
        [:div.level-right
         (if loading-metadata?
           [:div.loader]
           (when (not template-questionnaire?)
             [questionnaire-status {:current-status (-> questionnaire :metadata :data :status)
                                    :on-change #(questions.db/update-questionnaire-status
                                                 {:questionnaire questionnaire-id
                                                  :status %})}]))]]]
      (if loading-metadata?
        [:div.loader]
        (when (and (contains? features-enabled :applied-analysis-creation)
                   (not template-questionnaire?))
          [:div.section.pt-0.pb-4.mt-0.mb-4
           [archives/archived-list questionnaire-type questionnaire-id]
           (when (not (#{"faq" "one-off"} questionnaire-type))
             [:<>
              [inference-jobs/inference-job-list questionnaire-id]])
           [:f> compare.answer/ComparisonControl questionnaire-id questions]]))]

     [:div.section.py-0
      [:f> section-tabs
       {:questionnaire-id questionnaire-id
        :current-section-id (:id current-section)
        :sections sections
        :loading  (-> questionnaire :sections :loading)
        :on-tab-selected #(questions.db/set-filters questionnaire-id {"section" %})}]]

     [:div.section.pt-0.pb-6.mb-6.question-list-paginated-list
      [:f> paginated-list/paginated-list
       {:view-config-path [config/app-db-key questionnaire-id]
        :table-class (if (seq (remove empty? comparisons))
                       nil
                       "is-striped")
        :table-style {:height "100%"}
        :columns (filter (fn [{:keys [features id]}]
                           (if template-questionnaire?
                             (contains? template-columns id)
                             (if features
                               (some features features-enabled)
                                 ;; Allow by default
                               true)))
                         columns)
        :search-enabled true
        :hide-pagination? true
        :header-content [:div.level.is-flex-shrink-1
                         [:div.level-left.is-flex-shrink-1
                          [:div.level-item.is-flex-shrink-1
                           (when (seq (remove empty? comparisons))
                             (let [comparison-count (count comparisons)]
                               [:div
                                [:span "Now comparing"]
                                (for [[idx {:keys [short-id target-questionnaire]}] (map-indexed vector comparisons)
                                      :when (seq target-questionnaire)
                                      :let [{:keys [custom-name filename template]} target-questionnaire
                                            last? (= idx (dec comparison-count))]]
                                  [:div.ml-2
                                   {:key idx
                                    :style {:display "inline-block"}}
                                   [:span (if template
                                            "Template"
                                            "Questionnaire")]
                                   [:b.mx-2 (or custom-name filename)]
                                   [ComparisonSymbol
                                    (if template
                                      "T"
                                      "Q")
                                    short-id]
                                   (when-not last?
                                     ",")])]))]
                          [:span.level-item>b {:title "Filter questions by"} "Active filters:"]
                          (when (empty? filters)
                            [:span.level-item "none"])
                          [:div.level-item.tags.mr-4
                           [:<> (map (partial filter->tag questionnaire-id) filters)]]]
                         [:div.level-right
                          [:div.level.item
                           (when filter-popup-visible?
                             [:f> question-filter-popup/question-filter-popup {:questionnaire-id questionnaire-id
                                                                               :template-questionnaire? template-questionnaire?}])]
                          [:div.is-seconadary.level-item>button.button.is-rounded.is-secondary
                           {:on-click #(questions.db/set-filter-popup-visibility true)
                            :title "Click to select filters to narrow the question list"}
                           [:span.icon>i.fas.fa-filter]
                           [:span "Filter by"]]]]
        :cell-classes []
        :cell-props-transform (fn [{:keys [disabled
                                           comparison-mode
                                           suggestion
                                           last-comparison-item]} props]
                                (cond-> props
                                  disabled
                                  (update :class (fnil conj []) "is-disabled")

                                  (or comparison-mode
                                      (and suggestion (not last-comparison-item)))
                                  (assoc-in [:style :border-bottom] 0)))
        :row-props-transform (fn [{:keys [comparison-mode]} props]
                               (cond-> props
                                 comparison-mode (assoc-in [:style :background-color] "#fafafa")))
        :column-editors (when (and (contains? features-enabled :applied-analysis-creation)
                                   (not template-questionnaire?)
                                   @(questions.db/column-visible?* :answer-scope))
                          {:answer-scope
                           (fn [selected-rows]
                             (let [[visible set-visible] (react/useState false)]
                               [:div
                                [:button.button.is-small.is-rounded.is-info
                                 {:on-click #(set-visible (not visible))}
                                 (str "Edit " (count selected-rows) " selected")]
                                (when visible
                                  [:div
                                   {:style {:position "absolute"
                                            :background "white"
                                            :z-index 20
                                            :border "3px dotted #AAA"
                                            :padding "24px"}}
                                   [:f> answer-scope/AnswerScope
                                    {:on-commit #(rf/dispatch [::answers/set-answer-scope
                                                               questionnaire-id
                                                               (set (map :id selected-rows))
                                                               %])}]])]))})}
       {:items questions
        :loading @(questions.db/loading-questions* questionnaire-id)
        :data-filter (fn [search-query {:keys [content selected-answer]}]
                       (utils/match-search-query search-query
                                                 (fn [query-word]
                                                   (or (utils/str-includes-icase? content query-word)
                                                       (utils/str-includes-icase? (or (:additional-information selected-answer)
                                                                                      (:comment selected-answer))
                                                                                  query-word)
                                                       (utils/str-includes-icase? (:response selected-answer)
                                                                                  query-word)
                                                       (utils/str-includes-icase? (-> selected-answer :analysis :content)
                                                                                  query-word)))))
        :default-sort-keyfn (juxt :section-ordinal :ordinal)
        :default-sort-order :asc}]]]))

(defn view []
  (let [features-enabled @(rf/subscribe [::common-subs/features-enabled])
        question-answer-view @(rf/subscribe [::questionnaire-list/present-question-answering true])
        toggle-view #(rf/dispatch [::questionnaire-list/toggle-question-answering (not question-answer-view)])]
   (if (and question-answer-view (contains? features-enabled :applied-analysis-creation))
     [:f> questions.view/view toggle-view]
     [:f> deprecated-table-view toggle-view])))